/**
 * Record-title typography variant.
 *
 * Record headings (claim / registration titles) default to the
 * editorial Cormorant display face. Tenants whose record titles
 * are SKU- or code-style - where a serif reads awkwardly - can
 * opt into an "operational" variant rendered in the plain sans face for
 * cleaner technical headings.
 *
 * Driven by the `record_title_variant` tenant setting (surfaced via
 * `useOrg().tenantSettings`). The default ("editorial") preserves the
 * current look for every existing tenant, so this is purely additive
 * and per-tenant - no other tenant is affected.
 *
 * Returns only the FONT-related utilities (family, style, weight); each
 * call site keeps its own size / colour / leading so the variant slots
 * into any heading without overriding its scale.
 */
export type RecordTitleVariant = "editorial" | "operational";

export function recordTitleFontClass(variant: string | undefined): string {
  return variant === "operational"
    ? "font-sans font-normal tracking-[-0.01em]"
    : "font-display font-normal";
}
